/* eslint-disable */
export default {
  schedule: 'Ajoita tapaaminen',
  prompt: 'Anna RingCentralille tilitietojesi käyttöoikeus.',
  saveAsDefault: 'Tallenna oletukseksi',
} as const;

// @key: @#@"schedule"@#@ @source: @#@"Schedule Meeting"@#@
// @key: @#@"prompt"@#@ @source: @#@"Please authorize RingCentral to access your account information."@#@
// @key: @#@"saveAsDefault"@#@ @source: @#@"Save as default"@#@
